export class DicerGlobalModel {

    /**
     * Fill values
     * 
     * @param values 
     */
    fill(values: Array<any>) {
    }

    /**
     * Format value
     * 
     * @param values
     * @param app
     * @param key
     */
    private format(values: Array<any>, key: string): bigint {
        let value = values.find(x => x.key == 'dicer_' + key);
        if (value) {
            return BigInt(value.value);
        } else {
            return BigInt(0);
        }
    }
}